/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  TelegramChatsUserControllerUpsertMutationRequest,
  TelegramChatsUserControllerUpsertMutationResponse,
  TelegramChatsUserControllerUpsert401,
  TelegramChatsUserControllerUpsert404,
} from '../types/TelegramChatsUserControllerUpsert.ts';

function getTelegramChatsUserUpsertUrl() {
  const res = { method: 'POST', url: `/api/user/telegram/chats` as const };
  return res;
}

/**
 * {@link /api/user/telegram/chats}
 */
export async function telegramChatsUserUpsert(
  data: TelegramChatsUserControllerUpsertMutationRequest,
  config: Partial<RequestConfig<TelegramChatsUserControllerUpsertMutationRequest>> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    TelegramChatsUserControllerUpsertMutationResponse,
    ResponseErrorConfig<TelegramChatsUserControllerUpsert401 | TelegramChatsUserControllerUpsert404>,
    TelegramChatsUserControllerUpsertMutationRequest
  >({ method: 'POST', url: getTelegramChatsUserUpsertUrl().url.toString(), data: requestData, ...requestConfig });
  return res.data;
}
